import { addPropertyIfExists, addBooleanPropertyIfExists } from './orderSummaryUtils';

export const getCloudOnboardingSummary = ({ orders = [] }) => {
    if (orders?.catalogServices && orders?.catalogServices?.length) {
        const result = orders?.catalogServices?.map((item) => {
            const { catalogConfig } = item || {};
            const orderItemDetails = {
                orderId: orders?.id,
                createdByGpId: orders?.created?.by?.id,
                catalogType: item?.catalogType,
                catalogServiceId: item?.catalogServiceId,
                catalogServiceCode: item?.catalogServiceCode,
                orderStatus: orders?.currentStatus?.status,
                applicationName: catalogConfig?.applicationName,
                questionnaireResponses: catalogConfig?.questionnaireResponses,
                summary: {},
                provisionedDetails: {},
            };

            orderItemDetails.summary = {
                ...addPropertyIfExists(catalogConfig?.accountType, 'Account Type', catalogConfig?.accountType?.toUpperCase()),
                ...addPropertyIfExists(catalogConfig?.businessApplication, 'Business Application'),
                ...addPropertyIfExists(catalogConfig?.applicationService, 'Application Service'),
                ...(catalogConfig?.environment?.length && catalogConfig?.environment[0] !== 'Sandbox' && addPropertyIfExists(catalogConfig?.sector, 'Sector')),
                ...(catalogConfig?.environment?.length && catalogConfig?.environment[0] !== 'Sandbox' && addPropertyIfExists(catalogConfig?.region, 'Region')),
                ...addPropertyIfExists(catalogConfig?.applicationRegion, 'Application Region'),
                ...(catalogConfig?.onboardingCategory === 'Sandbox' && addPropertyIfExists(catalogConfig?.sector, 'Sector')),
                ...addPropertyIfExists(catalogConfig?.department, 'Department'),
                ...addPropertyIfExists(catalogConfig?.sharedNetworkAccountId, 'Account ID'),
                ...addPropertyIfExists(catalogConfig?.sharedNetworkAccountName, 'Account Name'),
                ...addPropertyIfExists(catalogConfig?.vpcName, 'VPC Name'),
                ...addPropertyIfExists(catalogConfig?.vpcId, 'VPC ID'),
                ...addPropertyIfExists(catalogConfig?.businessCategory, 'Business Category'),
                ...addPropertyIfExists(catalogConfig?.awsAccountName, 'AWS Account Name'),
                ...addPropertyIfExists(catalogConfig?.ouName, 'OU Name'),
                ...addPropertyIfExists(catalogConfig?.ouId, 'OU ID'),
                ...addPropertyIfExists(catalogConfig?.businessSponsor, 'Business Sponsor', catalogConfig?.businessSponsor?.name),
                ...addPropertyIfExists(
                    catalogConfig?.environment?.length,
                    'Environment',
                    Array.isArray(catalogConfig?.environment) ? catalogConfig?.environment?.join(',  ') : catalogConfig?.environment
                ),
                ...addPropertyIfExists(catalogConfig?.costCenter, 'Cost Center'),
                ...addPropertyIfExists(catalogConfig?.onPremCostCenter, 'On-Prem Cost Center'),
                ...addPropertyIfExists(catalogConfig?.dataClassification, 'Data Classification'),
                ...addPropertyIfExists(catalogConfig?.additionalInformation, 'Additional Information'),
                ...addPropertyIfExists(catalogConfig?.typeOfCloud, 'Type Of Cloud'),
                ...addPropertyIfExists(catalogConfig?.onboardingCategory, 'Onboarding Category'),
                ...addPropertyIfExists(catalogConfig?.isaNumber, 'ISA Number'),
                ...addBooleanPropertyIfExists(catalogConfig?.isChinaOnboarding, 'Is China Onboarding'),
                ...addPropertyIfExists(catalogConfig?.cloudTechDocLink, 'CloudTech Document Link'),
                ...addPropertyIfExists(catalogConfig?.tacRequest, 'TAC Request'),
                ...addPropertyIfExists(catalogConfig?.csaApproval, 'CSA Approval', catalogConfig?.csaApproval?.name),
                ...addPropertyIfExists(catalogConfig?.previousCloudOnboardingRequest, 'Previous CloudOnboarding Request'),
                ...addPropertyIfExists(catalogConfig?.adGroup, 'AD Group', catalogConfig?.adGroup?.name),
                ...addPropertyIfExists(
                    catalogConfig?.readerAdGroups,
                    'Reader AD Group',
                    Array.isArray(catalogConfig?.readerAdGroups)
                        ? catalogConfig?.readerAdGroups?.map((app) => app?.name).join(',  ')
                        : catalogConfig?.readerAdGroups
                ),
                ...addPropertyIfExists(
                    catalogConfig?.contributorAdGroups,
                    'Contributor AD Group',
                    Array.isArray(catalogConfig?.contributorAdGroups)
                        ? catalogConfig?.contributorAdGroups?.map((app) => app?.name).join(',  ')
                        : catalogConfig?.contributorAdGroups
                ),
                ...addPropertyIfExists(catalogConfig?.activeDirectoryGroupOwnerId, 'AD Group Owner'),
                ...((catalogConfig?.applicationName || (catalogConfig?.onboardingCategory === 'Sandbox' && orders?.entityDetails)) &&
                    addPropertyIfExists(
                        catalogConfig?.onboardingCategory !== 'Sandbox' ? catalogConfig?.applicationName : orders?.entityDetails?.name,
                        'Application Name'
                    )),
                ...addPropertyIfExists(catalogConfig?.applicationShortName, 'Application Short Name'),
                ...addPropertyIfExists(catalogConfig?.awsAccountOnboardOrderId, 'AWS Account Onboard Order ID'),
                ...addPropertyIfExists(catalogConfig?.attachments, 'uploadArchitecture'),
                ...addPropertyIfExists(catalogConfig?.cloudReadynessScore, 'Cloud Readiness Score', catalogConfig?.cloudReadynessScore || 'N/A'),
                ...addBooleanPropertyIfExists(catalogConfig?.isIsolatedAccount, 'Isolated Account'),
                ...addBooleanPropertyIfExists(catalogConfig?.edrsEnabled, 'EDRS Enabled'),
            };

            orderItemDetails.provisionedDetails = item?.provisionedDetails || {};

            return orderItemDetails;
        });
        return result || [];
    }
    return [];
};
export default getCloudOnboardingSummary;
